import { Box, Paper, Stack, TableContainer, Typography } from "@mui/material";
import { useId, type CSSProperties, type ReactNode } from "react";

export interface PageTileProps {
  title?: ReactNode;
  actions?: ReactNode;
  scrollable?: boolean;
  overflow?: CSSProperties["overflow"];
  children: ReactNode;
}

export const PageTile = ({ title, actions, scrollable = false, overflow, children }: PageTileProps) => {
  const titleId = useId();

  return (
    <Paper component="section" variant="outlined" aria-labelledby={title ? titleId : undefined} sx={{ p: 2, minWidth: 0, overflowWrap: "anywhere", overflow }}>
      {title && (
        <Stack direction={{ xs: "column", md: "row" }} spacing={2} sx={{ alignItems: { xs: "stretch", md: "center" }, justifyContent: "space-between", mb: 2 }}>
          <Typography id={titleId} component="h3" variant="h6">
            {title}
          </Typography>
          {actions && <Box sx={{ flexShrink: 0 }}>{actions}</Box>}
        </Stack>
      )}
      <Box component={scrollable ? TableContainer : "div"} sx={{ typography: "body1", overflowWrap: scrollable ? "normal" : undefined }}>
        {children}
      </Box>
    </Paper>
  );
};
